export enum ChatMemberRole {
  SELLER = "SELLER",
  BUYER = "CUSTOMER",
  ADMIN = "ADMIN",
}
